import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ToolbarItem = styled.div`
  padding: 0 0.5em;
  display: flex;
  align-items: center;
`;

const Item = ({ children }) =>
  <ToolbarItem>
    {children}
  </ToolbarItem>;

Item.propTypes = {
  children: PropTypes.node,
};

export default Item;
